module.exports = __webpack_public_path__ + "media/app/javascript/images/invalid-85ce74a06fa0a6299384a56d96684d1c.svg";